import React from 'react';

import './Content.css';

interface Props {
  children: React.ReactElement;
}

const Content: React.FC<Props> = props => {
  return <div className="ui-widget-content">{props.children}</div>;
};

export default Content;
